import React from "react";
import { Link } from "react-router-dom";
import {
  Facebook,
  Twitter,
  Instagram,
  Mail,
  Phone,
  MapPin,
} from "lucide-react";

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img
                src="/logo.png"
                alt="ETB Tours Egypt"
                className="h-10 w-auto"
              />
              <div className="flex flex-col">
                <span className="text-xl font-bold text-teal-400">
                  ETB Tours Egypt
                </span>
                <span className="text-xs text-red-400 font-medium">
                  Since 1989
                </span>
              </div>
            </div>
            <p className="text-gray-300 mb-4">
              ETB Tours Egypt is a leading tourism company in Egypt which is
              specialist in Egypt tours, Egypt travel packages, Egypt Nile
              Cruises, Cairo day tours, Egypt Classic tour packages.
            </p>
            <div className="flex space-x-4">
              <button
                className="text-gray-300 hover:text-white transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </button>
              <button
                className="text-gray-300 hover:text-white transition-colors"
                aria-label="Twitter"
              >
                <Twitter className="w-5 h-5" />
              </button>
              <button
                className="text-gray-300 hover:text-white transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </button>
            </div>
          </div>

          {/* Tour agency */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Tour agency</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-gray-300 hover:text-teal-400 transition-colors"
                >
                  Egypt Tours
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-gray-300 hover:text-teal-400 transition-colors"
                >
                  Transfers
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-gray-300 hover:text-teal-400 transition-colors"
                >
                  Jordan Tours
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-gray-300 hover:text-teal-400 transition-colors"
                >
                  Spiritual & Pilgrimage Tours
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-gray-300 hover:text-teal-400 transition-colors"
                >
                  Tours for seniors Citizens
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-gray-300 hover:text-teal-400 transition-colors"
                >
                  Turkey Tours
                </Link>
              </li>
            </ul>
          </div>

          {/* footer.contact_title */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-gray-300 hover:text-teal-400 transition-colors"
                >
                  home
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-gray-300 hover:text-teal-400 transition-colors"
                >
                  Travel guide
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-gray-300 hover:text-teal-400 transition-colors"
                >
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-gray-300 hover:text-teal-400 transition-colors"
                >
                  About us
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-gray-300 hover:text-teal-400 transition-colors"
                >
                  contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Info</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <MapPin className="w-4 h-4 text-teal-400" />
                <span className="text-gray-300">
                  4 El Lebeny Axis, Nazlet Al Batran, Al Haram, Giza, Egypt
                </span>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="w-4 h-4 text-teal-400" />
                <span className="text-gray-300">+201021100873</span>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="w-4 h-4 text-teal-400" />
                <span className="text-gray-300">info@etbtours.com</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="text-gray-300">
            © Copyright 2025 . All Rights Reserved ETB Tours
          </p>
          <p className="text-gray-400 text-sm mt-2">
            Powered by{" "}
            <span className="text-teal-400 font-medium">Floki Systems</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
